/* global axios */

const FLOW_CONFIG_KEYS = [
  'flow_i_manage',
  'has_access_manage_flow',
  'has_access_manage_chat',
  'has_access_manage_ai',
  'has_chat_enabled',
  'has_access_manage_employee',
  'head_office',
  'id_provider',
];

export default {
  getConfig() {
    const baseUrl = window.chatwootConfig?.apiBaseUrl;
    const confs = encodeURIComponent(
      JSON.stringify({ flow: FLOW_CONFIG_KEYS })
    );
    return axios.get(`${baseUrl}/v1/config?confs=${confs}`);
  },
};
